import {
    Component,
    ComponentFactoryResolver,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    QueryList,
    SimpleChange,
    ViewChildren
} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {RendementBrutComponent} from '@components/kpi/rendement-brut/rendement-brut.component';
import {RendementNetComponent} from '@components/kpi/rendement-net/rendement-net.component';
import {TauxChomageComponent} from '@components/kpi/taux-chomage/taux-chomage.component';
import {TauxEtudiantComponent} from '@components/kpi/taux-etudiant/taux-etudiant.component';
import {TotalTravauxComponent} from '@components/kpi/total-travaux/total-travaux.component';
import {CashFlowComponent} from '@components/kpi/cash-flow/cash-flow.component';
import {KpiDirective} from '@components/kpi/kpi.directive';
import {MensualiteComponent} from '@components/kpi/mensualite/mensualite.component';
import {NiveauVieComponent} from '@components/kpi/niveau-vie/niveau-vie.component';
import {TauxLogementVacantComponent} from '@components/kpi/taux-logement-vacant/taux-logement-vacant.component';
import {TauxProprietaireComponent} from '@components/kpi/taux-proprietaire/taux-proprietaire.component';
import {TauxLocataireComponent} from '@components/kpi/taux-locataire/taux-locataire.component';
import {HabitantComponent} from '@components/kpi/habitant/habitant.component';
import {TotalSortieComponent} from '@components/kpi/total-sortie/total-sortie.component';
import {NgForOfContext} from '@angular/common';
import {TotalPriceComponent} from '@components/kpi/total-price/total-price.component';
import {SquareComponent} from '@components/kpi/square/square.component';
import {SquarePriceComponent} from '@components/kpi/square-price/square-price.component';
import {SquarePriceDiffComponent} from '@components/kpi/square-price-diff/square-price-diff.component';
import {PartTravauxComponent} from '@components/kpi/part-travaux/part-travaux.component';
import {TotalLoyerComponent} from '@components/kpi/total-loyer/total-loyer.component';
import {FirstDateComponent} from '@components/kpi/first-date/first-date.component';
import {SquareRentComponent} from '@components/kpi/square-rent/square-rent.component';
import {SquareWorkComponent} from '@components/kpi/square-work/square-work.component';
import {CitySquarePriceComponent} from '@components/kpi/city-square-price/city-square-price.component';
import {CityEfficiencyComponent} from '@components/kpi/city-efficiency/city-efficiency.component';
import {Favorite} from '@models/favorite';
import {EMPTY_FAVORITE} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';
import {SimulatorComponent} from '@components/kpi/simulator/simulator.component';
import {ChangeCityComponent} from '@components/kpi/change-city/change-city.component';
import {FiscaMobileComponent} from '@components/kpi/fisca-mobile/fisca-mobile.component';
import {PriceComponent} from '@components/kpi/price/price.component';
import {PriceCityEvolComponent} from '@components/kpi/price-city-evol/price-city-evol.component';
import {TensionLocativeComponent} from '@components/kpi/tension-locative/tension-locative.component';

@Component({
    selector: 'app-ad-kpis',
    templateUrl: './kpis.component.html',
    styleUrls: ['./kpis.component.scss']
})
export class KpisComponent implements OnChanges, OnInit {

    @ViewChildren(KpiDirective) widgets: QueryList<KpiDirective>;

    @Input() favorite: Favorite = Object.assign({}, EMPTY_FAVORITE);
    @Input() kpis: string[];
    @Input() cpt: number = 0;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();
    length = 0;
    sub = [];

    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        public dialog: MatDialog,
        public authenticationService: AuthenticationService) {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
        if (changes.cpt !== undefined && changes.cpt.firstChange == false) {
            this.sub.forEach(s => {
                s.emit();
            });
            return
        }

        if (this.kpis !== undefined) {
            this.buidWidget();

            setTimeout(() => {
                this.buidWidget();
            }, 100);
        }
    }

    buidWidget() {
        if (this.widgets === undefined) {
            return;
        }
        if (this.kpis.length === 5 || (this.kpis.length === 6 && this.kpis[5] === "fisca-mobile")) {
            this.length = 20;
        } else {
            this.length = 12 / this.kpis.length;
        }

        this.sub = [];
        this.widgets.forEach(function(widget) {
            let componentFactory: any;
            let widgetName = '';

            if (widget.viewContainerRef._hostLView && widget.viewContainerRef._hostLView.context && widget.viewContainerRef._hostLView.context.$implicit) {
                widgetName = widget.viewContainerRef._hostLView.context.$implicit;
            } else if (widget.viewContainerRef._hostLView && widget.viewContainerRef._hostLView) {
                widget.viewContainerRef._hostLView.forEach(elem => {
                    if (elem instanceof NgForOfContext) {
                        widgetName = elem.$implicit;
                    }
                });
            }

            if (widgetName === '' && widget.viewContainerRef.__ngContext__ && widget.viewContainerRef.__ngContext__) {
                widget.viewContainerRef.__ngContext__.forEach(elem => {
                    if (elem instanceof NgForOfContext) {
                        widgetName = elem.$implicit;
                    }
                });
            }

            switch (widgetName) {
                case 'rendement-brut':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(RendementBrutComponent);
                    break;
                case 'rendement-net':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(RendementNetComponent);
                    break;
                case 'taux-chomage':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(TauxChomageComponent);
                    break;
                case 'taux-etudiant':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(TauxEtudiantComponent);
                    break;
                case 'total-travaux':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(TotalTravauxComponent);
                    break;
                case 'cash-flow':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(CashFlowComponent);
                    break;
                case 'mensualite':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(MensualiteComponent);
                    break;
                case 'niveau-vie':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(NiveauVieComponent);
                    break;
                case 'taux-logement-vacant':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(TauxLogementVacantComponent);
                    break;
                case'taux-proprietaire':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(TauxProprietaireComponent);
                    break;
                case 'taux-locataire':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(TauxLocataireComponent);
                    break;
                case 'habitant':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(HabitantComponent);
                    break;
                case 'total-sortie':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(TotalSortieComponent);
                    break;
                case 'total-loyer':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(TotalLoyerComponent);
                    break;
                case 'price':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(PriceComponent);
                    break;
                case 'total-price':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(TotalPriceComponent);
                    break;
                case 'square':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(SquareComponent);
                    break;
                case 'square-price':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(SquarePriceComponent);
                    break;
                case 'square-price-diff':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(SquarePriceDiffComponent);
                    break;
                case 'price-city-evol':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(PriceCityEvolComponent);
                    break;
                case 'part-travaux':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(PartTravauxComponent);
                    break;
                case 'first-date':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(FirstDateComponent);
                    break;
                case 'square-rent':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(SquareRentComponent);
                    break;
                case 'square-work':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(SquareWorkComponent);
                    break;
                case 'city-square-price':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(CitySquarePriceComponent);
                    break;
                case 'city-efficiency':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(CityEfficiencyComponent);
                    break;
                case 'simulator':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(SimulatorComponent);
                    break;
                case 'change-city':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(ChangeCityComponent);
                    break;
                case 'fisca-mobile':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(FiscaMobileComponent);
                    break;
                case 'tension-locative':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(TensionLocativeComponent);
                    break;
            }
            const viewContainerRef = widget.viewContainerRef;
            viewContainerRef.clear();

            if (componentFactory) {
                const componentRef = viewContainerRef.createComponent(componentFactory);
                (componentRef.instance).favorite = this.favorite;
                (componentRef.instance).preview = this.preview;
                if (componentRef.instance.favoriteChange !== undefined) {
                    componentRef.instance.favoriteChange.subscribe(data => {
                        this.favoriteChange.emit(data);
                        this.sub.forEach(s => {
                            s.emit();
                        });
                    });
                }

                if (componentRef.instance.extChange !== undefined) {
                    this.sub.push(componentRef.instance.extChange);
                }
            }

        }.bind(this));
    }

}
